<template>
  <div class="main-page page-case"
       :style="{ background: isXiaodu && `url('https://qiniu.terminal.laway.cn/bg-img.png') !important`}">
    <Menu title="案例库查询"
          :home="true" />
    <div class="case-info"
         :style="{ color: isXiaodu && '#333' }">本案例库内容均来自于“中国裁判文书网”，提供的信息仅供查询人参考，内容以正式文本为准。非法使用裁判文书库信息给他人造成损害的，由非法使用人承担法律责任。</div>
    <div class="search-panel">
      <input class="form-control"
             type="text"
             placeholder="请输入您想要查找的关键词进行搜索"
             v-model="searchVal">
      <button @click="getSearch"> <i class="glyphicon glyphicon-search"></i> 搜索</button>
    </div>
    <div class="main-block"
         :style="{ 'margin-top': isXiaodu && '70px' }">
      <div class="left-nav"
           :style="{ height: isXiaodu && '85vh', background: isXiaodu && 'rgba(34,34,34,0.5)' }">
        <template v-for="(navitem ,index) in caseSort">
          <div v-if="navitem.hasData"
               :key="'key-nav'+index"
               @click="setType(index,navitem)"
               :class="['item','txtone',index==current?'active':'']">
            {{navitem.name}}
          </div>
        </template>
      </div>
      <div class="right-con"
           id="caseright"
           v-infinite-scroll="loadmore"
           :infinite-scroll-disabled="loading"
           infinite-scroll-immediate-check="false"
           infinite-scroll-distance="10">
        <div class="list-box">
          <div class="list-title">
            {{currentitle}} > 全部
          </div>
          <div class="item"
               v-for="(item,index) in caselist"
               @click="getDetail(item)"
               :key="'key-d'+index">
            <div class="imgs">
              <img src="/img/ui/yasfcase.png"
                   width="43"
                   alt="">
            </div>
            <div class="intro ">
              <div class="title">
                {{item.title}}
              </div>
              <div class="desc">
                <span v-if="item.caseReason">
                  案由：{{item.caseReason}}
                </span>
                <span v-if="item.caseReason">
                  •
                </span>
                <span v-if="item.courtName">
                  法院：{{item.courtName}}
                </span>
                <span v-if="item.judgmentDate">
                  •
                </span>
                <span v-if="item.judgmentDate">
                  判决日期：{{$moment(item.judgmentDate).format('YYYY-MM-DD HH:mm')   }}
                </span>
                <span v-if="item.createTime">
                  •
                </span>
                <span v-if="item.createTime">
                  添加日期：{{item.createTime  }}
                </span>
              </div>

            </div>
          </div>
          <div class="foot">
            <div class="tip"
                 v-if="loadover">已经全部加载</div>
            <div class="more-link"
                 v-else>
              <a href="javascript:void(0)">加载更多</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Rightslide v-model="slide"
                @getClose="getClose">
      <template slot="content">
        <div class="title">
          {{detail.title}}
        </div>
        <template v-if="detail.htmlContent">
          <div class="detail"
               v-html="detail.htmlContent" />
        </template>
        <div class="detail"
             v-else
             v-html="detail.content">
        </div>
      </template>
    </Rightslide>
  </div>
</template>
<script>
import Menu from '../../components/Menu'
import Rightslide from '../../components/RightSlide'
import * as caseApi from '../../datas/js/case'
import { JUDGNENT_CASE } from '../../datas/constants/statistics.js'
const markdown = require('markdown').markdown
export default {
  components: {
    Menu,
    Rightslide
  },

  data () {
    return {
      caseSort: [],
      caselist: [],
      slide: {
        show: false
      },
      isXiaodu: localStorage.getItem('xiaodu') || false,
      current: 0,
      page: [],
      loading: false,
      loadover: false,
      isPost: false,
      post: '',
      firstloading: false,
      currentitle: '',
      detail: '',
      model: {
        pageSize: 20,
        pageNo: 1,
        professionalId: ''
      },
      searchVal: ''
    }
  },
  computed: {
    appInfo () {
      return this.$store.getters['app/getAppInfo']
    }
  },
  async mounted () {
    this.$root.getStatistics(JUDGNENT_CASE)
    this.firstloading = true
    if (!this.appInfo.appId) {
      await this.$store.dispatch('app/getAppInfoBySite')
    }
    this.getCaseKind()
  },
  methods: {
    getClose () {
      this.detail = ''
      this.slide.show = false
    },
    getSearch () {
      this.model.pageNo = 1
      this.loadover = false
      this.getCaseList()
    },
    getCaseKind () {
      caseApi.getCaseKind({ type: 1, }).then(res => {
        if (res.response.success) {
          let list = res.data || []
          this.caseSort = list.filter(item => {
            return item.hasData
          })
          this.model.professionalId = this.caseSort[0].id
          this.getCaseList()
        } else {
          console.log('[ got an error response ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ catch an error ]', error)
      })
    },
    getCaseList () {
      this.currentitle = this.caseSort.length ? this.caseSort[this.current].name : ''
      caseApi.getCaseList({ ...this.model, professionalId: this.searchVal ? null : this.model.professionalId, title: this.searchVal || null }).then(res => {
        if (res.response.success) {
          let list = res.data ? res.data.result : []
          if (!list.length || list.length < this.model.pageSize) {
            this.loading = false
            this.loadover = true
          }

          this.caselist = this.model.pageNo > 1 ? this.caselist.concat(list) : list
        } else {
          console.log('[ got an error response ]', res.response.msg)
        }
      })
    },
    getDetail (item) {
      caseApi.getCaseDetail(item.id).then(res => {
        if (res.response.success) {
          this.slide.show = true
          this.detail = res.data || {}
          if (this.detail.content) {
            this.detail.content = this.detail.content.includes('DOCTYPE') || this.detail.content.includes('<div') ? this.detail.content : markdown.toHTML(this.detail.content)
          }
        } else {
          console.log('[ got an error response ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ catch an error ]', error)
      })
    },
    loadmore () {
      if (this.loadover) {
        return
      }
      this.loading = true
      this.model.pageNo = this.model.pageNo + 1
      setTimeout(async () => {
        await this.getCaseList()
        this.loading = false
      }, 1000)
    },
    setType (index, item) {
      $('#caseright').scrollTop(0, 1000) // eslint-disable-line
      this.loading = true
      this.current = index
      this.currentitle = item.name
      this.model.pageNo = 1
      this.model.professionalId = item.id
      this.loadover = false
      this.searchVal = ''
      this.caselist = []
      this.getCaseList()
    }
  }
}
</script>
<style lang="stylus">
.page-case
  .case-info
    width 16rem
    font-size 0.2rem
    color #fff
    margin 0 auto
    text-align center
  .search-panel
    margin 0.1rem 1.6rem
    background #fff
    height 0.7rem
    border-radius 12px
    padding 4px
    display flex
    input
      flex 1
      height 100%
      text-align center
      padding 0 0.2rem
      border 0
      color #333
      font-size 0.22rem
      outline 0 !important
      box-shadow none !important
      &:focus
        border 0 !important
        outline 0 !important
        box-shadow none !important
    button
      width 360px
      height 100%
      background-color #2a69e0
      border-radius 10px
      color #fff
  .main-block
    flex 1
    overflow hidden
    padding 0.15rem 1.6rem 0.3rem
    display flex
    flex-wrap wrap
    .left-nav
      flex-shrink 0
      width 3.2rem
      height 100%
      margin-right 0.4rem
      overflow-y scroll
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
      .item
        height 0.8rem
        line-height 0.8rem
        font-size 0.26rem
        color rgba(255, 255, 255, 0.9)
        padding 0 0.35rem
        background-color rgba(255, 255, 255, 0.2)
        border-radius 0.08rem
        border solid 1px rgba(255, 255, 255, 0.2)
        margin-bottom 0.05rem
        &.active
          background #f29530
    .right-con
      flex 1
      border-radius 0.1rem
      background #fff
      height 100%
      overflow-y scroll
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
    .list-box
      border-radius 0.1rem
      background #fff
      .list-title
        height 0.74rem
        border-radius 0.1rem 0.1rem 0 0
        font-size 0.24rem
        line-height 0.74rem
        background-color #fff
        padding 0 0.34rem
        border-bottom 1px solid #e5e5e5
        color #333333
      .item
        position relative
        background #fff
        padding 0.25rem 0.35rem
        box-sizing border-box
        display flex
        &:active
          background #f7f7f7
        &:after
          content ''
          position absolute
          bottom 0
          left 0.35rem
          right 0.35rem
          border-bottom 1px solid #e5e5e5
        &:last-child
          border-radius 0 0 0.1rem 0.1rem
        .imgs
          width 0.9rem
          height 0.9rem
          border-radius 50%
          margin-right 0.16rem
          background-color #edf3ff
          text-align center
          line-height 0.9rem
          flex-shrink 0
        .intro
          padding-right 0.3rem
          overflow hidden
          display flex
          flex-direction column
          justify-content center
          overflow hidden
          span
            color #ccc
            padding 0 0.1rem
        .title
          font-size 0.24rem
          color #333333
          line-height 1
          width 100%
          margin-bottom 0.1rem
          line-height 1.5
        .desc
          font-size 0.18rem
          color #666666
          line-height 1.6
    .foot
      padding 0.4rem 0
      font-size 0.2rem
      text-align center
      color #999
      a
        color #999
        text-decoration none
  .slide-box
    .slide-box-content
      width 8rem
      padding 0 0.4rem
      .title
        font-size 0.36rem
        line-height 1.4
        font-weight 600
        padding 0.6rem 0 0.2rem 0
      .intro
        background-color #eee
        padding 0.2rem
        color #999
        font-size 0.16rem
        line-height 1.4
      .detail
        line-height 1.8
        font-size 0.22rem
        img
          max-width 100%
        p
          margin 1em 0 !important
          font-size 0.22rem !important
        .mpda_bottom_container
          h2:first-child
            display none
  .footerslide
    .btns
      width 8rem
</style>
